<template>
  <div>
    <div :class="bgFlag?'tarnsf':''">
      <div class="iheader"
           :class="moveFlag?'bgColor':''">
        <h1 class="ihed_h1">
          <img src="~@/assets/images/svg/logo_top_black.svg"
               class="logo_pic"
               @click="toHome()"
               v-show="!bgFlag" />
          <img src="~@/assets/images/svg/logo_top_white.svg"
               class="logo_pic"
               @click="toHome()"
               v-show="bgFlag" />
        </h1>
        <div class="herg">
          <span class="herg_lang"
                @click='changeLang()'>{{lang}}</span>
          <i class="herg_mu"
             @click="nuneClick(1)"></i>
        </div>
      </div>
    </div>
    <div class="hdplace"></div>
    <div class="imageList">
      <div class="bread">
        <div class="breSel"
             v-show="selFlag">
          <div class="breSel_inner">
            <p class="breSel_p"
               v-for="(item,index) in joList"
               @click="changeList(item)"
               :key="'pap'+index"> {{item.title}}</p>
          </div>

        </div>
        <div class="bread_lf"
             :class="selFlag ?'active':''"
             @click="conChange()">
          <span class="bread_nu">{{joName}}</span>
          <i class="sel_ico"></i>

        </div>
        <div class="bread_rg">
          <transition name="fade">
            <i class="fg"
               @click="imageChange()"
               v-show="imageShow"></i>
          </transition>
          <transition name="fade">
            <i class="rgmu"
               @click="wzChange()"
               v-show="wzShow"></i>
          </transition>
        </div>
      </div>
      <div class="tujsu"
           v-show="imageShow">
        <div class="jorBan"
             @click="torzDetail(newBoxFrist.id)"
             v-if="!!newBoxFrist">
          <div class="maskm"></div>
          <!-- <img :src="newBoxFrist.pic"
               class="jorBan_pic" /> -->
          <van-image fit="cover"
                     :src="newBoxFrist.pic"
                     class="jorBan_pic">
            <template v-slot:loading>
              <van-loading type="spinner"
                           size="0" />
            </template>
          </van-image>
          <span class="jor_mask">{{newBoxFrist.category}}</span>
          <div class="jorBan_in">
            <p class="jorin_p1 ">{{newBoxFrist.ptime}}</p>
            <p class="jorin_p2 fontS">{{newBoxFrist.title}}</p>
            <p class="jorin_p3">{{newBoxFrist.desp}}</p>
            <span class="jorin_sp">继续阅读</span>
          </div>
        </div>
        <div class="jorCon clearfix">
          <van-list v-model="loading"
                    :finished="finished"
                    :offset="offset"
                    finished-text="没有更多了"
                    @load="onLoad">
            <div class="clearfix">
              <div class="jorCon_li jorCon_li1"
                   :class="'jdCon_li'+(index+1)%10"
                   v-for="(item,index) in newBoxList"
                   :key="'new'+index"
                   @click="torzDetail(item.id)">
                <span class="jor_mask">{{item.category}}</span>
                <van-image fit="cover"
                           :src="item.pic"
                           class="jorli_pic">
                  <template v-slot:loading>
                    <van-loading type="spinner"
                                 size="0" />
                  </template>
                </van-image>
                <!-- <img :src="item.pic"
                     class="jorli_pic" /> -->
                <div class="jdertt">
                  <p class="jorli_p1 fontS">{{item.title}}</p>
                  <p class="jorli_p2">{{item.ptime}}</p>
                  <p class="jorli_p3">{{item.desp}}</p>
                </div>

              </div>
            </div>
          </van-list>
          <div class="newLoading"
               v-show="loadFlag"><span>{{langFlag ?'loading':'正在加载中' }}~</span></div>

          <!-- <div class="jorCon_li jorCon_li1"
               @click="torzDetail()">
            <span class="
             jor_mask">探索发现</span>
            <img src="~@/assets/images/rizhi/rz_pic1.jpg"
                 class="jorli_pic" />
            <p class="jorli_p1">玻璃在建筑空间的运用</p>
            <p class="jorli_p2">2021/12/26</p>
            <p class="jorli_p3">随着时代的变迁、社会的发展，人们对待美的观念也
              逐渐发生着变化。由于现代主义建筑革命深刻地改变
              了传统的建筑美学观念。</p>
          </div> -->
          <!-- <div class="jorCon_li jorCon_li2"
               @click="torzDetail()">
            <span class="jor_mask">人物介绍</span>
            <img src="~@/assets/images/rizhi/rz_pic2.jpg"
                 class="jorli_pic" />
            <p class="jorli_p1">伯纳德· 屈米设计作品解读</p>
            <p class="jorli_p2">2021/12/26</p>
            <p class="jorli_p3">随着时代的变迁、社会的发展，人们对待美的观念也
              逐渐发生着变化。由于现代主义建筑革命深和研究。</p>
          </div>
          <div class="jorCon_li jorCon_li3"
               @click="torzDetail()">
            <span class="jor_mask">新讯</span>
            <img src="~@/assets/images/rizhi/rz_pic3.jpg"
                 class="jorli_pic" />
            <p class="jorli_p1">2018 IDAF首届上海创新设计建筑论坛</p>
            <p class="jorli_p2">2021/12/26</p>
            <p class="jorli_p3">随着时代的变迁、社会的发展，人们对待美的观念也
              逐渐发生着变化。由于现代主义建筑革命深刻地改变
              了传统的建筑美学观念。</p>
          </div>
          <div class="jorCon_li jorCon_li4"
               @click="torzDetail()">
            <span class="jor_mask">关注思考</span>
            <img src="~@/assets/images/rizhi/rz_pic4.jpg"
                 class="jorli_pic" />
            <p class="jorli_p1">赫克托·吉玛德作品探析</p>
            <p class="jorli_p2">2021/12/26</p>
            <p class="jorli_p3">随着时代的变迁、社会的发展，人们对待美的观念也
              逐渐发生着变化。由于现代主义建筑革命深刻地改变
              了传统的建筑美学观念研究。</p>
          </div>
          <div class="jorCon_li jorCon_li5"
               @click="torzDetail()">
            <span class="jor_mask">专题分享</span>
            <img src="~@/assets/images/rizhi/rz_pic5.jpg"
                 class="jorli_pic" />
            <p class="jorli_p1">建筑叙事性设计探索</p>
            <p class="jorli_p2">2021/12/26</p>
            <p class="jorli_p3">随着时代的变迁、社会的发展，人们对待美的观念也逐渐发生着变化。由于现代主义建筑革命深刻地改变了传统
              的建筑美学观念，建筑风格多元化逐渐形成，因此更应该从更深层次的角度对建筑去进行思考和研究。</p>
          </div>
          <div class="jorCon_li jorCon_li6"
               @click="torzDetail()">
            <span class="jor_mask">探索发现</span>
            <img src="~@/assets/images/rizhi/rz_pic6.jpg"
                 class="jorli_pic" />
            <p class="jorli_p1">光能建筑·庭园家</p>
            <p class="jorli_p2">2021/12/26</p>
            <p class="jorli_p3">随着时代的变迁、社会的发展，人们对待美的观念也逐
              渐发生着变化。由于现代主义建筑革命深刻地改变了传
              统的建筑美学观念。</p>
          </div>
          <div class="jorCon_li jorCon_li7"
               @click="torzDetail()">
            <span class="jor_mask">关注思考</span>
            <img src="~@/assets/images/rizhi/rz_pic7.jpg"
                 class="jorli_pic" />
            <p class="jorli_p1">创建完美用户体验供应链</p>
            <p class="jorli_p2">2021/12/26</p>
            <p class="jorli_p3">随着时代的变迁、社会的发展，人们对待美的观念也逐
              渐发生着变化。由于现代主义建筑革命深刻地改变了传
              统的建筑美学观念，建筑风格多元化逐渐形成，因此更
              应该从更深层次的角度对建筑去进行思考和研究。</p>
          </div>
          <div class="jorCon_li jorCon_li8"
               @click="torzDetail()">
            <span class="jor_mask">探索发现</span>
            <img src="~@/assets/images/rizhi/rz_pic8.jpg"
                 class="jorli_pic" />
            <p class="jorli_p1">身处彩云知南</p>
            <p class="jorli_p2">2021/12/26</p>
            <p class="jorli_p3">灾教育展示中心的意义：防灾教育展示中心的修建，
              已经有很多的现实意义在说明它的重要性，它的目的
              就是要为更多的人提供防灾教育培训及多种体验项
              目，利用参观者的亲身体验和自身感受为主的教育培
              训方式，使体验者及参观者更深刻地了解到防灾教育
              的重要性。。</p>
          </div>
          <div class="jorCon_li jorCon_li9"
               @click="torzDetail()">
            <span class="jor_mask">关注思考</span>
            <img src="~@/assets/images/rizhi/rz_pic9.jpg"
                 class="jorli_pic" />
            <p class="jorli_p1">北岳建筑设计及其文化理念</p>
            <p class="jorli_p2">2021/12/26</p>
            <p class="jorli_p3">灾教育展示中心的意义：防灾教育展示中心的修建，
              已经有很多的现实意义在说明它的重要性，它的目的
              就是要为的重要性。</p>
          </div>
          <div class="jorCon_li jorCon_li10"
               @click="torzDetail()">
            <span class="jor_mask">专题分享</span>
            <img src="~@/assets/images/rizhi/rz_pic10.jpg"
                 class="jorli_pic" />
            <p class="jorli_p1">创建完美用户体验供应链</p>
            <p class="jorli_p2">2021/12/26</p>
            <p class="jorli_p3">随着时代的变迁、社会的发展，人们对待美的观念也逐渐发生着变化。由于现代主义建筑革命深刻地改变了传统
              的建筑美学观念，建筑风格多元化逐渐形成，因此更应该从更深层次的角度对建筑去进行思考和研究。</p>
          </div>
          <div class="jorCon_li jorCon_li11"
               @click="torzDetail()">
            <span class="jor_mask">关注思考</span>
            <img src="~@/assets/images/rizhi/rz_pic11.jpg"
                 class="jorli_pic" />
            <p class="jorli_p1">建筑与环境的表达</p>
            <p class="jorli_p2">2021/12/26</p>
            <p class="jorli_p3">随着时代的变迁、社会的发展，人们对待美的观念也
              逐渐发生着变化。由于现代主义建筑革命深和研究。</p>
          </div>
          <div class="jorCon_li jorCon_li12"
               @click="torzDetail()">
            <span class="jor_mask">探索发现</span>
            <img src="~@/assets/images/rizhi/rz_pic12.jpg"
                 class="jorli_pic" />
            <p class="jorli_p1">论现代建筑设计方法的创新</p>
            <p class="jorli_p2">2021/12/26</p>
            <p class="jorli_p3">随着时代的变迁、社会的发展，人们对待美的观念也
              逐渐发生着变化。由于现代主义建筑革命深刻地改变
              了传统的建筑美学观念。</p>
          </div> -->
        </div>
        <!-- <span class="jour_more">载入更多</span> -->
      </div>

      <div class="jorWcon"
           v-show="wzShow">
        <van-list v-model="loading"
                  :finished="finished"
                  :offset="offset"
                  finished-text="没有更多了"
                  @load="onLoad">
          <div class="jorWcon_li clearfix"
               v-for="(item,index) in newBoxList"
               :key="'box'+index"
               @click="torzDetail(item.id)">
            <span class="ztfx">{{item.category}}</span>
            <div class="jorWcon_lf">
              <van-image fit="cover"
                         :src="item.pic"
                         class="wz_pic">
                <template v-slot:loading>
                  <van-loading type="spinner"
                               size="0" />
                </template>
              </van-image>
              <!-- <img :src="item.pic"
                   class="wz_pic" /> -->
            </div>
            <div class="jorWcon_rg">
              <p class="jorWcon_rg_p1 fontS">{{item.title}}</p>
              <p class="jorWcon_rg_p2">{{item.ptime}}</p>
            </div>
          </div>
        </van-list>
        <div class="newLoading"
             v-show="loadFlag"><span>{{langFlag ?'loading':'正在加载中' }}~</span></div>
        <!-- <div class="jorWcon_li clearfix"
             @click="torzDetail()">
          <span class="ztfx">专题分享</span>
          <div class="jorWcon_lf">
            <img src="~@/assets/images/rizhi/xx_pic1.jpg"
                 class="wz_pic" />
          </div>
          <div class="jorWcon_rg">
            <p class="jorWcon_rg_p1">山中湖与水神殿</p>
            <p class="jorWcon_rg_p2">2022/01/12</p>
          </div>
        </div>
        <div class="jorWcon_li clearfix"
             @click="torzDetail()">
          <span class="ztfx">专题分享</span>
          <div class="jorWcon_lf">
            <img src="~@/assets/images/rizhi/xx_pic2.jpg"
                 class="wz_pic" />
          </div>
          <div class="jorWcon_rg">
            <p class="jorWcon_rg_p1">玻璃在建筑空间的运用</p>
            <p class="jorWcon_rg_p2">2022/01/12</p>
          </div>
        </div>
        <div class="jorWcon_li clearfix"
             @click="torzDetail()">
          <span class="ztfx">人物介绍</span>
          <div class="jorWcon_lf">
            <img src="~@/assets/images/rizhi/xx_pic3.jpg"
                 class="wz_pic" />
          </div>
          <div class="jorWcon_rg">
            <p class="jorWcon_rg_p1">伯纳德· 屈米设计作品解读</p>
            <p class="jorWcon_rg_p2">2022/01/12</p>
          </div>
        </div>
        <div class="jorWcon_li clearfix"
             @click="torzDetail()">
          <span class="ztfx">新讯</span>
          <div class="jorWcon_lf">
            <img src="~@/assets/images/rizhi/xx_pic4.jpg"
                 class="wz_pic" />
          </div>
          <div class="jorWcon_rg">
            <p class="jorWcon_rg_p1">2020 IDAF首届
              上海创新设计建筑论坛
            </p>
            <p class="jorWcon_rg_p2">2022/01/12</p>
          </div>
        </div>
        <div class="jorWcon_li clearfix"
             @click="torzDetail()">
          <span class="ztfx">探索发现</span>
          <div class="jorWcon_lf">
            <img src="~@/assets/images/rizhi/xx_pic5.jpg"
                 class="wz_pic" />
          </div>
          <div class="jorWcon_rg">
            <p class="jorWcon_rg_p1">这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题</p>
            <p class="jorWcon_rg_p2">2022/01/12</p>
          </div>
        </div>
        <div class="jorWcon_li clearfix"
             @click="torzDetail()">
          <span class="ztfx">专题分享</span>
          <div class="jorWcon_lf">
            <img src="~@/assets/images/rizhi/xx_pic6.jpg"
                 class="wz_pic" />
          </div>
          <div class="jorWcon_rg">
            <p class="jorWcon_rg_p1">这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题</p>
            <p class="jorWcon_rg_p2">2022/01/12</p>
          </div>
        </div> -->
      </div>
      <gotop></gotop>
      <!-- footer -->
      <!-- footer -->
      <foot @contact="contact"></foot>
      <transition name="slide-fade">
        <munePage v-show="muneFlag"
                  :muneFlag="muneFlag"
                  :muneIndex="muneIndex"
                  @closeMu="closeMu"
                  @muneChange='muneIndexChange'></munePage>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { WOW } from 'wowjs'
import foot from '@/components/foot.vue'
import gotop from '@/components/goTop.vue'
import munePage from '@/pages/munePage.vue'
import { mapMutations, mapGetters, mapState } from 'vuex'
import { Lazyload } from 'vant'
import { Image as VanImage } from 'vant'
Vue.use(VanImage)
Vue.use(Lazyload)
export default {
  data() {
    return {
      bgFlag: false,
      imageShow: true,
      wzShow: false,
      mySwiper: null,
      muneFlag: false,
      muneIndex: 2,
      selFlag: false,
      papName: '全部文章',
      moveFlag: false,
      journaId: '',
      boxList: [],
      pageNum: 0, // 当前页码
      pageSize: 10, // 分页大小
      total: 0, // 查询总条数
      loading: false, // 滚动加载中
      finished: false, // 滚动加载完成
      offset: 50, //滚动条与底部距离小于 offset 时触发load事件，默认300
      joList: [],
      joName: '',
      newBoxList: [],
      newBoxFrist: {},
      contTit: '日志列表',
      loadFlag: false,
      loadName: '正在加载中',
    }
  },
  components: { foot, gotop, munePage },
  computed: {
    ...mapState(['langFlag', 'lang']),
  },

  mounted() {
    document.title = this.contTit
    this.newsCate()
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false,
      })
      wow.init()
    })
    // 滚动条滚动
    window.addEventListener('scroll', this.handleScroll)
  },
  watch: {
    langFlag(val) {
      console.log('中英文的值', val)
      this.pageNum = 0
      this.joName = ''
      this.newBoxList = []
      this.joList = []
      this.newBoxFrist = {}
      this.newsCate()
      if (val) {
        this.contTit = 'list'
        document.title = this.contTit
      } else {
        this.contTit = '日志列表'
        document.title = this.contTit
      }
    },
  },
  methods: {
    imageChange() {
      this.imageShow = false
      this.wzShow = true
    },
    wzChange() {
      this.imageShow = true
      this.wzShow = false
    },
    // 菜单
    nuneClick(index) {
      this.muneFlag = true
      this.muneIndex = 2
    },
    closeMu(val) {
      this.muneFlag = false
      // this.pageNum = 0
      // this.joName = ''
      // this.newBoxList = []
      // this.joList = []
      // this.newBoxFrist = {}
      // this.newsCate()
    },
    contact() {
      this.muneFlag = true
      this.muneIndex = 3
    },
    muneIndexChange(index) {
      this.muneIndex = index
    },
    torzDetail(newsId) {
      this.$router.push({
        name: 'journal',
        query: {
          newsId: newsId,
        },
      })
    },
    conChange() {
      this.selFlag = !this.selFlag
    },
    changeList(val) {
      this.joName = val.title
      this.journaId = val.id
      this.pageNum = 0
      this.newBoxList = []
      this.news(this.journaId)
      this.selFlag = false
    },
    handleScroll() {
      // 页面滚动距顶部距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var winH =
        document.documentElement.clientHeight || document.body.clientHeight
      var scroll = scrollTop - this.i
      this.i = scrollTop
      if (scroll <= 0) {
        this.moveFlag = false
      } else {
        this.moveFlag = true
      }
      if (scrollTop < winH) {
        this.bgFlag = false
      } else {
        this.bgFlag = true
      }

      // let t1 = document.documentElement.scrollTop || document.body.scrollTop
      // if (t1 > 10) {
      //   this.moveFlag = true
      // } else {
      //   this.moveFlag = false
      // }
    },
    //切换语言
    changeLang() {
      // this.SET_WFFLAG(true)
      console.log('语言1', this.langFlag)
      this.$store.commit('setLang', !this.langFlag)
      this.$store.commit('setLa', this.lang == 'EN' ? 'CH' : 'EN')
      console.log('语言', this.langFlag)
    },
    // 返回首页
    toHome() {
      this.$router.push({
        name: 'home',
        // query: {
        //   type: type,
        // },
      })
    },

    //获取日志分类
    newsCate() {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'newsCate',
        that.$qs.stringify({
          type: type,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            that.joList = response.data
            that.joName = that.joList[0].title
            that.journaId = that.joList[0].id
            that.news(that.journaId)
            console.log('ddd', that.joList)
          }
        })
        .catch(function (error) {})
    },
    // 获取日志列表
    news(id) {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'news',
        that.$qs.stringify({
          type: type,
          cateId: id,
          size: 4,
          page: that.pageNum,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            that.total = response.data.total //总页数

            let allNum = that.pageNum + 1
            if (allNum > that.total) {
              // that.finished = true
              that.loadFlag = false
              alet(0)
            } else {
              that.newBoxList = that.newBoxList.concat(response.data.data) || []
              that.newBoxFrist = that.newBoxList[0] || {}
              // that.finished = false
              that.loadFlag = true
              that.pageNum = that.pageNum + 1
            }
            that.loading = false
            that.loadFlag = false
          }
        })
        .catch(function (error) {})
    },

    // 滚动加载更多
    onLoad() {
      // console.log(1111)
      let that = this
      this.loading = true
      this.loadFlag = true
      alert(that.total, that.pageNum)
      if (that.pageNum < that.total) {
        setTimeout(function () {
          that.news(that.id)
        }, 300)
      }
    },
  },
}
</script>
<style >
.van-loading__text {
  opacity: 0;
}
.van-list__error-text,
.van-list__finished-text,
.van-list__loading {
  display: none;
}
</style>






// WEBPACK FOOTER //
// src/pages/journalList.vue